var amdi18n={"__root":{"add_recovery_strategy":"Adding recovery strategy","selecting_recovery_strategies":"Selecting recovery strategies","skip_not_usable_strategy":"Skipping not usable recovery strategy","no_strategy_available":"No recovery strategy available","strategy_not_found":"Recovery strategy not found","stopping_strategy":"Stopping recovery strategy","stopped_strategy":"Stopped recovery strategy"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/service/nls/RecoveryStrategyManager_strings.js
// module id = 299
// module chunks = 4